import styled from "styled-components";
import { TextInput, typoV2_CSS } from "oolib";

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 0.8rem;
  cursor: text;
`;

export const StyledTextInput = styled(TextInput)`
  flex: 1;
  min-width: 0;

  /* Strip InputContainerStyled border/hover/focus (uses ::before pseudo-element) */
  & > div {
    padding-inline: 1rem;

    &::before {
      display: none;
    }

    /* Ensure input font matches TextInput exactly, bypassing className reliance */
    input {
      ${typoV2_CSS.UI_BODY_SM_DF}
    }
  }
`;
